export const siteName = '神马电影网';

export const heroStats = [
  { id: 's1', label: '收录影片', value: '1,286', unit: '部' },
  { id: 's2', label: '口碑榜单', value: '9', unit: '个' },
  { id: 's3', label: '高分影片', value: '342', unit: '部' },
  { id: 's4', label: '今日更新', value: '28', unit: '条' },
];

export const updateTicker = [
  '《星际穿越》重回科幻高分榜前列，重映版口碑持续走高',
  '「什么电影好看」本周新增悬疑专题，含 12 部高口碑作品',
  '豆瓣高分整理：9 分以上经典片单已更新至 40 部',
  '《千与千寻》连续多月位居动画类口碑榜第一',
  '新上榜：《疯狂动物城》进入合家欢必看推荐',
  '口碑电影专区新增观众长评摘录，支持一键查看',
  '榜单说明：本站评分为公开口碑整理，仅供参考',
];

export const genres = ['全部', '剧情', '科幻', '悬疑', '动画', '动作', '喜剧', '爱情', '犯罪'];

export interface Movie {
  id: string;
  title: string;
  year: number;
  region: string;
  genres: string[];
  douban: number;
  heat: number;
  word: number;
  oneLiner: string;
}

export const movies: Movie[] = [
  { id: 'm01', title: '肖申克的救赎', year: 1994, region: '美国', genres: ['剧情', '犯罪'], douban: 9.7, heat: 96, word: 99, oneLiner: '关于希望与自由最经典的注脚，长期稳居口碑榜首。' },
  { id: 'm02', title: '霸王别姬', year: 1993, region: '中国大陆 / 中国香港', genres: ['剧情', '爱情'], douban: 9.6, heat: 92, word: 98, oneLiner: '时代洪流里的执念与成全，表演与叙事都难以复刻。' },
  { id: 'm03', title: '阿甘正传', year: 1994, region: '美国', genres: ['剧情', '爱情'], douban: 9.5, heat: 88, word: 95, oneLiner: '一盒巧克力的两种活法，把人生过成一场长跑。' },
  { id: 'm04', title: '这个杀手不太冷', year: 1994, region: '法国', genres: ['剧情', '动作'], douban: 9.4, heat: 85, word: 93, oneLiner: '冷酷与温柔只隔一盆绿植，孤独者的相互照亮。' },
  { id: 'm05', title: '泰坦尼克号', year: 1997, region: '美国', genres: ['爱情', '剧情'], douban: 9.5, heat: 90, word: 94, oneLiner: '灾难与爱情的经典范式，一句台词记了二十多年。' },
  { id: 'm06', title: '千与千寻', year: 2001, region: '日本', genres: ['动画', '剧情'], douban: 9.4, heat: 89, word: 96, oneLiner: '宫崎骏想象力与东方美学的高峰，常看常新。' },
  { id: 'm07', title: '美丽人生', year: 1997, region: '意大利', genres: ['剧情', '喜剧'], douban: 9.5, heat: 82, word: 94, oneLiner: '用笑容替孩子挡住黑暗，温柔得让人心碎。' },
  { id: 'm08', title: '星际穿越', year: 2014, region: '美国', genres: ['科幻', '剧情'], douban: 9.4, heat: 94, word: 93, oneLiner: '爱与时间的相对论，硬核科幻里的柔软内核。' },
  { id: 'm09', title: '盗梦空间', year: 2010, region: '美国', genres: ['科幻', '悬疑'], douban: 9.4, heat: 91, word: 92, oneLiner: '层层嵌套的梦境迷宫，考验观众也奖励观众。' },
  { id: 'm10', title: '楚门的世界', year: 1998, region: '美国', genres: ['剧情', '科幻'], douban: 9.4, heat: 80, word: 93, oneLiner: '当生活是一场真人秀，你还敢推开门吗。' },
  { id: 'm11', title: '忠犬八公的故事', year: 2009, region: '美国', genres: ['剧情'], douban: 9.4, heat: 74, word: 91, oneLiner: '等待是最长情的告白，关于陪伴与守候。' },
  { id: 'm12', title: '三傻大闹宝莱坞', year: 2009, region: '印度', genres: ['喜剧', '剧情'], douban: 9.2, heat: 83, word: 90, oneLiner: '别让梦想被分数绑架，笑着笑着就被治愈。' },
  { id: 'm13', title: '让子弹飞', year: 2010, region: '中国大陆', genres: ['动作', '喜剧'], douban: 9.0, heat: 86, word: 89, oneLiner: '黑色幽默里的锋利台词，越品越有味道。' },
  { id: 'm14', title: '疯狂动物城', year: 2016, region: '美国', genres: ['动画', '喜剧'], douban: 9.2, heat: 84, word: 90, oneLiner: '在偏见之外的世界里，勇敢做自己的主角。' },
  { id: 'm15', title: '无间道', year: 2002, region: '中国香港', genres: ['犯罪', '悬疑'], douban: 9.3, heat: 79, word: 92, oneLiner: '卧底身份的致命拉扯，港片叙事的巅峰之一。' },
  { id: 'm16', title: '指环王3：王者无敌', year: 2003, region: '美国 / 新西兰', genres: ['动作', '科幻'], douban: 9.3, heat: 76, word: 90, oneLiner: '史诗三部曲的终章，关于责任、友谊与告别。' },
  { id: 'm17', title: '当幸福来敲门', year: 2006, region: '美国', genres: ['剧情'], douban: 9.2, heat: 78, word: 88, oneLiner: '为梦想守住低谷，普通人的坚持最动人。' },
  { id: 'm18', title: '哈尔的移动城堡', year: 2004, region: '日本', genres: ['动画', '爱情'], douban: 9.1, heat: 77, word: 89, oneLiner: '爱与勇气的魔法屋，一部温柔又浪漫的动画。' },
];

export interface HotPick {
  id: string;
  title: string;
  year: number;
  region: string;
  douban: number;
  reason: string;
  poster: string;
}

export const hotRecommend: HotPick[] = [
  {
    id: 'h1',
    title: '星际穿越',
    year: 2014,
    region: '美国',
    douban: 9.4,
    reason: '把相对论讲成一场父女之间的思念，硬核设定与情感落点兼顾，适合想看「大银幕震撼」的你。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20art%20of%20an%20astronaut%20silhouette%20before%20a%20vast%20glowing%20wormhole%2C%20deep%20space%2C%20warm%20amber%20and%20dusty%20light%2C%20atmospheric%20grain%2C%20no%20text&width=600&height=800&seq=shenma-poster-01&orientation=portrait',
  },
  {
    id: 'h2',
    title: '霸王别姬',
    year: 1993,
    region: '中国大陆 / 中国香港',
    douban: 9.6,
    reason: '戏与人生互为镜像，主角的每次转身都写满时代重量，是中文影史绕不开的必看之作。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20poster%20of%20a%20traditional%20Chinese%20opera%20performer%20in%20ornate%20costume%2C%20dramatic%20red%20stage%20light%2C%20warm%20tones%2C%20no%20text&width=600&height=800&seq=shenma-poster-02&orientation=portrait',
  },
  {
    id: 'h3',
    title: '千与千寻',
    year: 2001,
    region: '日本',
    douban: 9.4,
    reason: '一条关于成长与记忆的奇幻旅程，画面与想象力都足够纯粹，全家一起看也毫无压力。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20poster%20of%20a%20lone%20girl%20on%20a%20lantern%20lit%20bridge%20in%20a%20magical%20spirit%20town%20at%20dusk%2C%20warm%20golden%20glow%2C%20no%20text&width=600&height=800&seq=shenma-poster-03&orientation=portrait',
  },
  {
    id: 'h4',
    title: '无间道',
    year: 2002,
    region: '中国香港',
    douban: 9.3,
    reason: '身份与命运的极致较量，台词句句经得起回味，喜欢港片与犯罪的观众不要错过。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20poster%20of%20two%20men%20in%20dark%20coats%20facing%20each%20other%20under%20moody%20urban%20shadows%2C%20noir%20atmosphere%2C%20muted%20warm%20light%2C%20no%20text&width=600&height=800&seq=shenma-poster-04&orientation=portrait',
  },
  {
    id: 'h5',
    title: '疯狂动物城',
    year: 2016,
    region: '美国',
    douban: 9.2,
    reason: '把成长与偏见装进一座动物城市，笑点密集还不失分寸，适合轻松解压的观影夜晚。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20poster%20of%20a%20bright%20bustling%20animal%20city%20skyline%2C%20cheerful%20warm%20colors%2C%20stylized%20illustration%2C%20no%20text&width=600&height=800&seq=shenma-poster-05&orientation=portrait',
  },
  {
    id: 'h6',
    title: '让子弹飞',
    year: 2010,
    region: '中国大陆',
    douban: 9.0,
    reason: '密集的黑色幽默与锋利台词，节奏爽快、解读空间巨大，值得和朋友边看边聊。',
    poster: 'https://readdy.ai/api/search-image?query=minimalist%20cinematic%20poster%20of%20a%20lone%20figure%20in%20a%20long%20coat%20on%20a%20dusty%20plain%20with%20a%20distant%20train%2C%20western%20drama%2C%20warm%20sepia%20tones%2C%20no%20text&width=600&height=800&seq=shenma-poster-06&orientation=portrait',
  },
];

export interface WordItem {
  id: string;
  title: string;
  year: number;
  douban: number;
  quote: string;
  tags: string[];
}

export const wordOfMouth: WordItem[] = [
  {
    id: 'w1',
    title: '肖申克的救赎',
    year: 1994,
    douban: 9.7,
    quote: '「希望是好事，也许是人间至善。」看完很久都缓不过来，常年在各类口碑榜里被反复提起。',
    tags: ['长期霸榜', '希望主题', '改编经典'],
  },
  {
    id: 'w2',
    title: '美丽人生',
    year: 1997,
    douban: 9.5,
    quote: '前半段笑得开心，后半段泪点密集。它用温柔的方式讲述沉重，是很多人心中的治愈片。',
    tags: ['治愈', '父爱', '笑着流泪'],
  },
  {
    id: 'w3',
    title: '楚门的世界',
    year: 1998,
    douban: 9.4,
    quote: '「假如再也见不到你，祝你早安、午安、晚安。」看完会忍不住重新打量自己的生活。',
    tags: ['哲思', '经典台词', '越看越深'],
  },
  {
    id: 'w4',
    title: '这个杀手不太冷',
    year: 1994,
    douban: 9.4,
    quote: '两个孤独的人互相照亮，一盆绿植成了关于陪伴的隐喻，浪漫又克制。',
    tags: ['孤独', '陪伴', '浪漫'],
  },
];

export interface DecadePick {
  id: string;
  decade: string;
  note: string;
  films: string[];
}

export const mustWatch: DecadePick[] = [
  {
    id: 'd1',
    decade: '1990 年代',
    note: '类型成熟、作者表达强烈的黄金十年，几乎每一部都被后来者反复致敬。',
    films: ['肖申克的救赎', '霸王别姬', '阿甘正传', '这个杀手不太冷', '泰坦尼克号', '美丽人生'],
  },
  {
    id: 'd2',
    decade: '2000 年代',
    note: '东方幻想、港片叙事与现实主义并行的阶段，情感表达更加细腻。',
    films: ['千与千寻', '无间道', '指环王3：王者无敌', '当幸福来敲门', '哈尔的移动城堡'],
  },
  {
    id: 'd3',
    decade: '2010 年代',
    note: '科幻设定与合家欢双线发力，观影门槛友好、讨论度高的作品集中出现。',
    films: ['星际穿越', '盗梦空间', '让子弹飞', '疯狂动物城', '三傻大闹宝莱坞'],
  },
];

export interface RankingItem {
  id: string;
  title: string;
  year: number;
  region: string;
  value: string;
  note: string;
}

export const rankingTabs = [
  {
    key: 'score',
    label: '高分榜',
    hint: '按整理评分由高到低排列',
    items: [
      { id: 'r1', title: '肖申克的救赎', year: 1994, region: '美国', value: '9.7', note: '口碑与评分双高' },
      { id: 'r2', title: '霸王别姬', year: 1993, region: '中国', value: '9.6', note: '中文影史代表作' },
      { id: 'r3', title: '阿甘正传', year: 1994, region: '美国', value: '9.5', note: '人生寓言' },
      { id: 'r4', title: '美丽人生', year: 1997, region: '意大利', value: '9.5', note: '温柔叙事' },
      { id: 'r5', title: '泰坦尼克号', year: 1997, region: '美国', value: '9.5', note: '灾难爱情经典' },
      { id: 'r6', title: '千与千寻', year: 2001, region: '日本', value: '9.4', note: '动画口碑高峰' },
      { id: 'r7', title: '星际穿越', year: 2014, region: '美国', value: '9.4', note: '硬核科幻' },
      { id: 'r8', title: '盗梦空间', year: 2010, region: '美国', value: '9.4', note: '结构精巧' },
      { id: 'r9', title: '这个杀手不太冷', year: 1994, region: '法国', value: '9.4', note: '孤独与温柔' },
      { id: 'r10', title: '楚门的世界', year: 1998, region: '美国', value: '9.4', note: '哲思之作' },
    ],
  },
  {
    key: 'heat',
    label: '热度榜',
    hint: '按站内浏览与讨论热度排列',
    items: [
      { id: 't1', title: '星际穿越', year: 2014, region: '美国', value: '94.2', note: '重映带动热度' },
      { id: 't2', title: '肖申克的救赎', year: 1994, region: '美国', value: '96.0', note: '常年霸榜' },
      { id: 't3', title: '霸王别姬', year: 1993, region: '中国', value: '92.1', note: '影史常青' },
      { id: 't4', title: '盗梦空间', year: 2010, region: '美国', value: '91.0', note: '二创热度高' },
      { id: 't5', title: '泰坦尼克号', year: 1997, region: '美国', value: '90.4', note: '经典重看' },
      { id: 't6', title: '千与千寻', year: 2001, region: '日本', value: '89.5', note: '动画顶流' },
      { id: 't7', title: '阿甘正传', year: 1994, region: '美国', value: '88.3', note: '长尾稳定' },
      { id: 't8', title: '让子弹飞', year: 2010, region: '中国', value: '86.7', note: '解读不断' },
      { id: 't9', title: '这个杀手不太冷', year: 1994, region: '法国', value: '85.2', note: '被反复安利' },
      { id: 't10', title: '疯狂动物城', year: 2016, region: '美国', value: '84.6', note: '合家欢首选' },
    ],
  },
  {
    key: 'word',
    label: '口碑榜',
    hint: '综合观众评价与推荐意愿',
    items: [
      { id: 'c1', title: '肖申克的救赎', year: 1994, region: '美国', value: '99', note: '几乎零差评' },
      { id: 'c2', title: '霸王别姬', year: 1993, region: '中国', value: '98', note: '表演封神' },
      { id: 'c3', title: '千与千寻', year: 2001, region: '日本', value: '96', note: '全年龄口碑' },
      { id: 'c4', title: '阿甘正传', year: 1994, region: '美国', value: '95', note: '治愈且耐看' },
      { id: 'c5', title: '泰坦尼克号', year: 1997, region: '美国', value: '94', note: '情感共鸣强' },
      { id: 'c6', title: '美丽人生', year: 1997, region: '意大利', value: '94', note: '温柔又深刻' },
      { id: 'c7', title: '这个杀手不太冷', year: 1994, region: '法国', value: '93', note: '浪漫克制' },
      { id: 'c8', title: '楚门的世界', year: 1998, region: '美国', value: '93', note: '引发思考' },
      { id: 'c9', title: '星际穿越', year: 2014, region: '美国', value: '92', note: '情感落点好' },
      { id: 'c10', title: '无间道', year: 2002, region: '中国香港', value: '92', note: '港片天花板' },
    ],
  },
];

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    id: 'f1',
    q: '神马电影网主要提供什么内容？',
    a: '本站围绕「什么电影好看」这一常见需求，把热门推荐、高分电影、豆瓣高分与口碑电影整理在同一页里。你可以按分类标签筛选、看榜单排序，也能直接阅读口碑摘录，快速判断一部片子是否合自己的口味。',
  },
  {
    id: 'f2',
    q: '怎么用这一页更快挑到想看的电影？',
    a: '如果你已经知道自己喜欢的类型，可以从上方「选片」区域的类型标签入手；如果完全没有方向，建议先看「热门推荐」和「豆瓣高分」两个板块，再结合「口碑电影」里的观众评价做最终决定。',
  },
  {
    id: 'f3',
    q: '高分电影就一定好看吗？',
    a: '不一定。评分只是大量观众共同判断的结果，偏向普适口味，不代表符合每个人的偏好。建议把评分当作参考，再结合影片类型、年代和自己的观影心情综合判断，冷门佳作往往分数不高但很适合特定观众。',
  },
  {
    id: 'f4',
    q: '页面里的评分和豆瓣评分是一回事吗？',
    a: '本站评分是依据公开口碑整理的参考数值，用于横向比较影片的整体评价高低，可能与某一平台当下的实时分数存在出入。榜单与评分仅作选片参考，具体数值请以对应平台的官方数据为准。',
  },
  {
    id: 'f5',
    q: '想找冷门或小众作品有推荐吗？',
    a: '可以在「选片」区域用搜索或类型标签筛选，把排序切换到口碑维度，往往能发现讨论度不高但评价扎实的作品。此外，「按年代挑片」板块里的清单也包含不少适合慢慢补看的老片。',
  },
];